import { render, staticRenderFns } from "./addStock.vue?vue&type=template&id=77528263&scoped=true&"
import script from "./addStock.vue?vue&type=script&lang=js&"
export * from "./addStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77528263",
  null
  
)

export default component.exports